import { render, staticRenderFns } from "./zipTaskBtns.vue?vue&type=template&id=3c75b2cc&scoped=true&"
import script from "./zipTaskBtns.vue?vue&type=script&lang=js&"
export * from "./zipTaskBtns.vue?vue&type=script&lang=js&"
import style0 from "./zipTaskBtns.vue?vue&type=style&index=0&id=3c75b2cc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c75b2cc",
  null
  
)

export default component.exports